function ExportersChillies() {
    return (
        <div>
            <h2>Exporters Chillies</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default ExportersChillies;